import Agilite from 'agilite'
import CoreEnums from '../../../../core/utils/enums'
import store from '../../../../store'
import VirtualServicesEnums from './enums'
import { getDataWithSync } from '../../../../db/dbSync'
import { STORES } from '../../../../db/indexedDB'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

export const readVirtualServices = (filters) => {
  return new Promise((resolve, reject) => {
    let qry = {}
    let response = null
    let errorMessage = null

    ;(async () => {
      try {
        for (const key in filters) {
          if (filters[key] !== '') {
            qry[key] = filters[key]
          }
        }

        response = await agilite.Connectors.execute(
          VirtualServicesEnums.profileKeys.ADMINISTRATION_VIRTUAL_SERVICES,
          VirtualServicesEnums.routeKeys.READ,
          {
            filter: JSON.stringify(qry),
            page: null,
            pageLimit: null
          }
        )

        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const readVirtualServicesPwa = (filters) => {
  return new Promise((resolve, reject) => {
    let qry = {}
    let errorMessage = null

    ;(async () => {
      try {
        for (const key in filters) {
          if (filters[key] !== '') {
            qry[key] = filters[key]
          }
        }

        const virtualServices = await getDataWithSync(STORES.VIRTUAL_SERVICES, {
          body: {
            filter: JSON.stringify(qry),
            page: null,
            pageLimit: null
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': VirtualServicesEnums.profileKeys.ADMINISTRATION_VIRTUAL_SERVICES,
              'route-key': VirtualServicesEnums.routeKeys.READ
            }
          }
        })

        resolve(virtualServices)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const createService = (data) => {
  return new Promise((resolve, reject) => {
    let response = null
    let errorMessage = null
    let timestamp = Date()

    ;(async () => {
      try {
        data.dateCreated = timestamp
        data.dateModified = timestamp
        data.createdBy = store.getState().auth.agiliteUser._id
        data.modifiedBy = store.getState().auth.agiliteUser._id
        data.entityRef = store.getState().core.entity._id

        response = await agilite.Connectors.execute(
          VirtualServicesEnums.profileKeys.ADMINISTRATION_VIRTUAL_SERVICES,
          VirtualServicesEnums.routeKeys.CREATE,
          {
            data: JSON.stringify(data)
          }
        )
        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const updateService = (data) => {
  return new Promise((resolve, reject) => {
    let response = null
    let errorMessage = null
    let timestamp = Date()

    ;(async () => {
      try {
        data.dateModified = timestamp
        data.modifiedBy = store.getState().auth.agiliteUser._id

        response = await agilite.Connectors.execute(
          VirtualServicesEnums.profileKeys.ADMINISTRATION_VIRTUAL_SERVICES,
          VirtualServicesEnums.routeKeys.UPDATE,
          {
            recordId: data._id,
            data: JSON.stringify(data)
          }
        )
        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}
